import styled from 'styled-components';
import colors from 'styles/colors';

import {
  Container as ModalContainer,
  Header as ModalHeader,
  Input as ModalInput,
  Content as ModalContent,
  Footer as ModalFooter,
} from 'styles/modals';

import { Checkbox as FormCheckbox } from 'styles/form';

export const IS_SORTING = 'is-sorting';
export const IS_DRAG_ELEMENT = 'draggableStyle';

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  height: 35px;
  border: 1px solid transparent;
  padding-right: 10px;
  transition: 0.1s box-shadow, 0.1s border linear;
  user-select: none;
`;

export const Container = styled(ModalContainer)`
  overflow: hidden;
`;

export const Header = styled(ModalHeader)`
  border-bottom: 0;
`;

export const SearchContainer = styled.div`
  padding: 0 50px 30px 50px;
  border-bottom: 1px solid ${colors.inactive};
`;

export const Input = styled(ModalInput)`
  padding: 8px 15px;
`;

export const SubHeader = styled.div`
  height: 65px;
  display: flex;
  align-items: center;
  padding: 0 70px;
  font-size: 14px;
  box-shadow: 0 1px 4px 0 ${colors.gray85};

  span {
    opacity: 0.8;
  }
`;

export const Content = styled(ModalContent)`
  height: 440px;
  overflow: auto;
  padding: 10px 45px;

  &:not(.${IS_SORTING}) ${RowContainer}:hover {
    i {
      opacity: 1;
    }

    box-shadow: 0 1px 4px 0 ${colors.gray90};
    border: 1px solid ${colors.inactive};
  }
`;

export const DragContainer = styled.div`
  width: 36px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: row-resize;
  height: 100%;
`;

export const DragIcon = styled.i`
  padding-left: 10px;
  opacity: 0;
  transition: 0.1s opacity linear;
  font-size: 18px;
  color: ${colors.inactive};
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Checkbox = styled(FormCheckbox)`
  margin-right: 30px;
`;

export const Footer = styled(ModalFooter)`
  box-shadow: 0 -1px 4px 0 ${colors.gray85};
`;
